"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffiliateCookie = exports.AFFILIATE_COOKIE_NAME = exports.removeOrderReferenceCookie = exports.getOrderReferenceCookie = exports.setOrderReferenceCookie = exports.ORDER_REFERENCE_COOKIE_NAME = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.ORDER_REFERENCE_COOKIE_NAME = 'orderReference';
const cookieOptions = { secure: process.env.NODE_ENV === 'production', sameSite: 'lax' };
const setOrderReferenceCookie = (orderReference) => {
    js_cookie_1.default.set(exports.ORDER_REFERENCE_COOKIE_NAME, orderReference, cookieOptions);
};
exports.setOrderReferenceCookie = setOrderReferenceCookie;
const getOrderReferenceCookie = () => {
    return js_cookie_1.default.get(exports.ORDER_REFERENCE_COOKIE_NAME);
};
exports.getOrderReferenceCookie = getOrderReferenceCookie;
const removeOrderReferenceCookie = () => {
    js_cookie_1.default.remove(exports.ORDER_REFERENCE_COOKIE_NAME);
};
exports.removeOrderReferenceCookie = removeOrderReferenceCookie;
exports.AFFILIATE_COOKIE_NAME = 'affiliate';
const getAffiliateCookie = () => {
    return js_cookie_1.default.get(exports.AFFILIATE_COOKIE_NAME);
};
exports.getAffiliateCookie = getAffiliateCookie;
